'use strict';

const {googleFieldMapping, irelandGoogleCountyFieldMapper} = require('./google-field-mapping-countries');

module.exports = {
    data() {
        return {
            autoComplete: null,
            addressFieldsHidden: true,
            enableEditShipping: false,
            enableEditBilling: false
        };
    },
    methods: {
        updateFieldValue(fieldId, value) {
            this.$store.commit('details/updateFieldValue', {formId: this.formId, fieldId, value});
            if (fieldId === 'ssn') {
                this.fillForm(value);
                return;
            }
            if (
                this.$store.getters['details/validateRGCInput'](this.formId) &&
                this.countryCode === 'NL' &&
                ((!this.enableEditShipping && this.formId === 'shippingAddress') ||
                    (!this.enableEditBilling && this.formId === 'billingAddress'))
            ) {
                this.getAddressByRGC(this.formId);
            }
        },
        getAddressByRGC(formId) {
            //rgc NL
            this.$store.dispatch('details/getAddressFromRGC', formId);
            this.addressFieldsHidden = false;
        },
        fillForm(value) {
            //ssn
            this.$store.dispatch('details/getAddressInfo', value);
        },
        layoutElements(elements) {
            const rows = [];
            elements.forEach((element) => {
                if (rows.length > element.position - 1) {
                    const row = rows[Math.floor(element.position - 1)];
                    row.push(element);
                    return;
                }

                rows.push([element]);
            });

            return rows;
        },
        fillAddress() {
            const place = this.autoComplete.getPlace();
            const mappedAddressFields = mapGoogleAddressFields(place.address_components, this.countryCode);

            for (const [fieldId, value] of Object.entries(mappedAddressFields)) {
                this.$store.commit('details/updateFieldValue', {
                    formId: this.formId,
                    fieldId,
                    value
                });
            }
            this.addressFieldsHidden = false;
        },
        initAutoComplete() {
            const addressSearchEl = document.getElementById(this.formId + '_addressSearch');
            if (!addressSearchEl) {
                this.autoComplete = null;
                return;
            }
            if (!this.autoComplete) {
                this.autoComplete = getAutocomplete(addressSearchEl, this.countryCode);
                this.autoComplete.addListener('place_changed', this.fillAddress);
            }
        },
        async initFieldsHK() {
            await this.$store.dispatch('details/setCityHK', this.formId);
            await this.$store.dispatch('details/setDistrictHK', this.formId);
            await this.$store.dispatch('details/setSubdistrictHK', this.formId);
        },
        formatAddress(addressFieldValues, format, addressFieldValueReplacement) {
            let formated = format;
            Object.keys(addressFieldValues).forEach((key) => {
                if (formated.includes('$' + key + '$')) {
                    const data =
                        addressFieldValueReplacement &&
                        addressFieldValueReplacement[key] &&
                        addressFieldValueReplacement[key][addressFieldValues[key]]
                            ? addressFieldValueReplacement[key][addressFieldValues[key]]
                            : addressFieldValues[key];
                    formated = formated.replace('$' + key + '$', data);
                }
            });

            return formated
                .trim()
                .replaceAll(/<br>\s*<br>/g, '<br>')
                .replace(/^<br>/, '');
        },
        getAddressById(addressId) {
            return this.$store.getters['addressBook/getAddressById'](addressId);
        },
        shouldShowHiddenFields(formRows) {
            const addressSearchIndex = formRows.findIndex((row) => row[0].id === 'addressSearch');
            const houseNumberExtensionIndex = formRows.findIndex((row) => row[0].id === 'addressSearchDummy');
            const index = addressSearchIndex !== -1 ? addressSearchIndex : houseNumberExtensionIndex;
            if (index === -1 && houseNumberExtensionIndex === -1) {
                return false;
            }

            return !formRows
                .slice(index + 1, formRows.length - 1)
                .some((row) =>
                    row.some(
                        (element) =>
                            (!!element.state.value && !element.attributes.readOnly) || element.validationErrors.length
                    )
                );
        }
    },
    computed: {
        isFormValidatedAndInvalid() {
            return this.$store.getters['details/isFormValidatedAndInvalid'](this.formId);
        },
        getCityHKValue() {
            if (this.countryCode !== 'HK') {
                return;
            }

            return this.$store.getters['details/getCityHKValue'](this.formId);
        },
        getDistrictHKValue() {
            if (this.countryCode !== 'HK') {
                return;
            }

            return this.$store.getters['details/getDistrictHKValue'](this.formId);
        }
    },
    watch: {
        isFormValidatedAndInvalid(isValidatedAndInvalid) {
            if (isValidatedAndInvalid && this.formRows) {
                this.addressFieldsHidden = this.shouldShowHiddenFields(this.formRows);
            }
        },
        getCityHKValue(newValue) {
            if (this.getCityHKValue && this.countryCode === 'HK' && newValue === this.getCityHKValue) {
                this.$store.dispatch('details/setDistrictHK', this.formId);
            }
        },
        getDistrictHKValue(newValue) {
            if (this.getDistrictHKValue && this.countryCode === 'HK' && newValue === this.getDistrictHKValue) {
                this.$store.dispatch('details/setSubdistrictHK', this.formId);
            }
        }
    },
    updated() {
        this.initAutoComplete();
    },
    mounted() {
        this.initAutoComplete();
        if (this.countryCode === 'HK') {
            this.initFieldsHK();
        }
    }
};

function getAutocomplete(element, country) {
    return new google.maps.places.Autocomplete(element, {
        types: ['address'],
        componentRestrictions: {country}
    });
}

function mapGoogleAddressFields(googleAddressFields, countryCode) {
    const countryMap = googleFieldMapping[countryCode] || googleFieldMapping['default'];
    const stateSelectorforCountries = ['US', 'IE'];
    return googleAddressFields.reduce((accumulator, currentField) => {
        const fieldId = countryMap[currentField.types[0]];
        const typeOfName =
            stateSelectorforCountries.indexOf(countryCode) >= 0 && (fieldId === 'stateUS' || fieldId === 'state')
                ? 'short_name'
                : 'long_name';

        if (!fieldId) {
            return accumulator;
        }

        let currentValue = currentField[typeOfName];
        if (countryCode === 'IE' && fieldId === 'state' && currentValue) {
            const potentialValue = irelandGoogleCountyFieldMapper[currentValue.toUpperCase()];
            if (!potentialValue) {
                return accumulator;
            }
            currentValue = potentialValue;
        }

        accumulator[fieldId] = accumulator[fieldId] ? accumulator[fieldId] + ' ' + currentValue : currentValue;

        return accumulator;
    }, {});
}
